import { useLocation } from 'react-router'

import useIsServerSide from './useIsServerSideContext'

const useSearchParams = () => {
  const isServerSide = useIsServerSide()
  const { search } = useLocation()

  if (isServerSide) {
    return undefined
  }

  return new URLSearchParams(search)
}

export default useSearchParams
